import React from 'react';
import { useTranslation } from 'react-i18next';
import Styled from '../style';
import { formatTime } from '../utils';

const PotentialViolations = ({ potentialViolations, heading }) => {
  const { i18n } = useTranslation();

  return (
    <Styled.DriverDashboard>
      {heading ? (
        <div className="dashboardComponents dashboardViolation">
          <div className="headingsWrapper">
            <span className="mainHeading">{i18n.t(heading)}</span>
          </div>
        </div>
      ) : (
        ''
      )}
      {!potentialViolations.length ? (
        <span className="noDatavioltion">{i18n.t('No data Available')}</span>
      ) : (
        <ul>
          {potentialViolations?.map((item) => {
            return item.items ? (
              <li>
                <span className="name">{item.items[0]}</span>
                <span className="id"> (ID:{item.items[1]})</span>
                <span className="message">{item.items[3]}</span>
              </li>
            ) : (
              <li>
                <span className="name">{formatTime(item.date)}</span>
                <span className="message">{item.description}</span>
              </li>
            );
          })}
        </ul>
      )}
    </Styled.DriverDashboard>
  );
};

export default PotentialViolations;

PotentialViolations.defaultProps = {};

PotentialViolations.propTypes = {};
